/**
 * The newsletter signup, as V1's Home tab did it (Rook, 2026-10-20): a sheet over the page with
 * Mailchimp's embedded form for the "Central City Getaway" audience, posting straight to Mailchimp
 * in a new tab (macfarlane-welcome-guide `NewsletterModal.jsx`: same action, fields, stay-type
 * groups and bot honeypot). Opened from My Stay after the stay and from the Feedback tab, where a
 * guide entry linking to Mailchimp's signup page opens this sheet instead of the full form.
 */
import { Icon, SheetModal } from '@pmh/shared';
import { useState } from 'react';

const ACTION =
  'https://centralcitygetaway.us14.list-manage.com/subscribe/post?u=ab64c8690d916b0054918e82f&id=c75fd0fdfc&f_id=00d1b8e5f0';
const HONEYPOT = 'b_ab64c8690d916b0054918e82f_c75fd0fdfc';

/** A guide link to Mailchimp's signup page (the Feedback tab's newsletter card). */
export function isNewsletterLink(link: string | null | undefined): boolean {
  return !!link && /list-manage\.com\/subscribe/.test(link);
}

export function NewsletterSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <SheetModal open={open} onClose={onClose} title="Join Our Newsletter">
      {open && <NewsletterForm />}
    </SheetModal>
  );
}

function NewsletterForm() {
  const [email, setEmail] = useState('');
  return (
    <form className="g-news" action={ACTION} method="post" target="_blank" name="mc-embedded-subscribe-form">
      <p className="g-news__kicker">Special Offers & Central City Highlights</p>
      <h3 className="pmh-display g-news__title">Get Our Newsletter for Special Offers & Local Highlights!</h3>
      <p className="pmh-body">
        Plus, four times a year one of our subscribers wins something special, from a gift box of local treats to a free weeknight at
        The MacFarlane Home!
      </p>
      <label className="pmh-field">
        <span className="pmh-field__label">
          Email Address <span aria-hidden="true">*</span>
        </span>
        <input
          className="pmh-input"
          type="email"
          name="EMAIL"
          required
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      <label className="pmh-field">
        <span className="pmh-field__label">First Name</span>
        <input className="pmh-input" type="text" name="FNAME" autoComplete="given-name" placeholder="Your first name" />
      </label>
      <fieldset className="g-news__groups">
        <legend>Preferred Type of Stay & Local Interests</legend>
        <label>
          <input type="checkbox" name="group[57926][1]" value="1" />
          Family-Friendly
        </label>
        <label>
          <input type="checkbox" name="group[57926][2]" value="2" />
          Adults-Only
        </label>
      </fieldset>
      {/* Mailchimp's bot trap: people never see or fill it. */}
      <div aria-hidden="true" style={{ position: 'absolute', left: -5000 }}>
        <input type="text" name={HONEYPOT} tabIndex={-1} defaultValue="" />
      </div>
      <button type="submit" name="subscribe" className="pmh-btn pmh-btn--primary pmh-btn--lg pmh-btn--block" disabled={!email.includes('@')}>
        <Icon name="mail" size={20} />
        Subscribe
      </button>
    </form>
  );
}
